import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  helperText?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, helperText, style, ...props }, ref) => {
    return (
      <div style={{ marginBottom: '1rem' }}>
        {label && (
          <label
            style={{
              display: 'block',
              marginBottom: '0.375rem',
              fontSize: 'var(--font-size-sm)',
              fontWeight: 500,
              color: 'var(--color-text)',
            }}
          >
            {label}
          </label>
        )}
        <div style={{ position: 'relative' }}>
          {icon && (
            <span
              style={{
                position: 'absolute',
                left: '0.75rem',
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--color-text-muted)',
                display: 'flex',
              }}
            >
              {icon}
            </span>
          )}
          <input
            ref={ref}
            style={{
              width: '100%',
              padding: '0.625rem 0.875rem',
              paddingLeft: icon ? '2.5rem' : '0.875rem',
              fontSize: 'var(--font-size-base)',
              border: `1px solid ${error ? 'var(--color-danger)' : 'var(--color-border)'}`,
              borderRadius: 'var(--radius-md)',
              background: 'var(--color-surface)',
              color: 'var(--color-text)',
              outline: 'none',
              transition: 'all var(--transition-fast)',
              fontFamily: 'var(--font-family)',
              ...style,
            }}
            onFocus={(e) => {
              e.target.style.borderColor = error ? 'var(--color-danger)' : 'var(--color-secondary)';
              e.target.style.boxShadow = `0 0 0 3px ${error ? 'rgba(231,76,60,0.1)' : 'rgba(45,95,138,0.1)'}`;
            }}
            onBlur={(e) => {
              e.target.style.borderColor = error ? 'var(--color-danger)' : 'var(--color-border)';
              e.target.style.boxShadow = 'none';
            }}
            {...props}
          />
        </div>
        {error && (
          <p style={{ marginTop: '0.25rem', fontSize: 'var(--font-size-sm)', color: 'var(--color-danger)' }}>
            {error}
          </p>
        )}
        {helperText && !error && (
          <p style={{ marginTop: '0.25rem', fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)' }}>
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
export default Input;
